module.exports = __webpack_public_path__ + "img/jiaoyu2.ec71a609.png";